var map = {
	"./frontpage.jpg": 180,
	"./intro-poster.jpg": 124,
	"./kanasta-scenario.png": 181,
	"./ko-to-tamo-scenario-1.png": 182,
	"./ko-to-tamo-scenario-2.png": 183,
	"./ko-to-tamo-scenario-3.png": 184,
	"./news.jpg": 431,
	"./news_kreka.jpg": 432,
	"./news_merima.png": 433,
	"./news_sloboda.png": 434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 430;